module.exports = __webpack_public_path__ + "static/img/home_new.e57691b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_new.jpeg
// module id = Rptp
// module chunks = 0